export default "__VITE_ASSET__CJjoojyi__"